<template>
  <div class="caption font-italic">
    <p>
      <sup>*</sup> Visual acuity (VA) is estimated based on how close the
      available lens is to the vertexed refraction. This information is provided
      to compare lens options. Many factors can influence VA, including - but
      not limited to - the patient's BCVA, lens rotation, and . . . multifocals.
      Furthermore, <i>VA estimates are assuming there is no accommodation</i>.
    </p>
    <p>
      <sup>&dagger;</sup> Annual prices are based on data from online vendors.
      Actual prices can vary due to many factors. This information is provided
      to compare relative prices between brands and modalities.
    </p>
  </div>
</template>

<script>
// import Name from "../dir/file";

export default {
  name: "SoftDisclaimers",
  props: {},
  data: function () {
    return {};
  },
  methods: {},
  computed: {},
};
</script>

<style scoped></style>
